import React from 'react';

export const TaxExempt = ({
  taxExempt,
  children,
  label,
}: {
  taxExempt?: string | null;
  children?: React.ReactNode;
  label?: string | null;
}) => (
  <div>
    <label>{label ? `${label} Tax exempt` : 'Tax exempt'}</label>
    <div data-testid="tax-exempt-flag">
      <span>{taxExempt ?? 'No'}</span>
      {children}
    </div>
  </div>
);
